
import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

( function( app ) {
  const COMPONENT = {
    init: function() {
    },
    finalize: function() {
      const container = document.querySelector( '.donate-cta__container' );
      const cutout = document.querySelector( '.donate-cta__cutout' );
      if ( !container || !cutout ) return;

      gsap.registerPlugin( ScrollTrigger );

      gsap.fromTo(
          cutout,
          {
            x: () => -cutout.offsetWidth,
          },
          {
            x: () => container.offsetWidth,
            ease: 'none',
            scrollTrigger: {
              trigger: container,
              start: 'top 50%',
              end: 'bottom 50%',
              scrub: 1,
              invalidateOnRefresh: true,
            },
          },
      );
    },
  };

  app.registerComponent( 'donate-cta', COMPONENT );
} )( app );
